import React, { useEffect, useState } from "react";
import css from "./HelpCenter.module.css";
import Navbar from "../../component/navbar/Navbar";
import { asyncStatus } from "../../utils/asyncStatus";
import { useDispatch, useSelector } from "react-redux";
import { contactUsAsync } from "../../services/authentication";
import { useNavigate } from "react-router-dom";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  CircularProgress,
  Container,
  Grid,
  IconButton,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { themeOrange } from "../../utils/colorTheme";
import { FaFacebook, FaInstagram, FaTwitter } from "react-icons/fa6";
import Footer from "../../screens/Footer/Footer";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const HelpCenter = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState({ name: "", email: "", message: "" });
  const navigate = useNavigate();
  const { contact_us_status } = useSelector((state) => state.userAuth);
  const isLoading = contact_us_status === asyncStatus.LOADING;

  const _handleSubmit = () => {
    dispatch(contactUsAsync(data));
  };

  const _clearDataState = () => {
    setData({ name: "", email: "", message: "" });
  };

  const _isEmpty = () => {
    const { name, email, message } = data;
    return !name || !email || !message;
  };

  const fields = [
    {
      _id: 1,
      label: "Full Name",
      value: data.name,
      onChange: (e) => setData({ ...data, name: e.target.value }),
      type: "text",
      disabled: false,
    },
    {
      _id: 1,
      label: "E-mail",
      value: "donerightaway44@gmail.com",
      onChange: (e) => setData({ ...data, name: e.target.value }),
      type: "email",
      disabled: true,
    },
  ];

  const vendorFields = [
    {
      _id: 2,
      label: "E-mail",
      value: data.email,
      onChange: (e) => setData({ ...data, email: e.target.value }),
      type: "email",
      disabled: false,
    },
    {
      _id: 2,
      label: "Phone Number",
      value: `+1 (289) 400-4962`,
      onChange: (e) => setData({ ...data, email: e.target.value }),
      type: "text",
      disabled: true,
    },
    {
      _id: 3,
      label: "Message",
      value: data.message,
      onChange: (e) => setData({ ...data, message: e.target.value }),
      type: "text",
      disabled: false,
    },
  ];

  const faqsData = [
    {
      category: "Services & Markets",
      questions: [
        {
          question: "What types of services can I request?",
          answer: [
            "Mobile Auto Detailing",
            "Mobile Auto Service",
            "Plumbing",
            "Pest Control",
            "Garage Door Repair",
            "Window & Eaves Cleaning",
            "Home Inspection",
            "Furniture Assembly",
            "Duct Cleaning",
            "Garbage Pickup",
            "Dry Cleaning",
            "Power Washing",
            "Handyman Services",
            "Lawn Maintenance",
            "Holiday Lights Installation",
            "Mobile Tire Change",
            "Appliance Installation",
            "Appliance Repair",
            "Locksmith Services",
            "Painting",
            "Moving & Delivery",
            "Gas Services",
            "BBQ Cleaning & Repair",
            "Carpet & Upholstery Cleaning",
            "Junk Removal",
            "Electrical Services",
            "Heating & Cooling",
            "Snow Removal",
            "$1 Flash Box",
          ],
        },
        {
          question: "Where can I request a service?",
          answer: [
            "Services can be requested for your home or office within the Greater Toronto Area and Ottawa. We plan to expand to additional cities in the near future.",
          ],
        },
      ],
      description:
        "We continuously expand our service categories. Feel free to suggest any new services you'd like us to offer.",
    },
    {
      category: "Account",
      questions: [
        {
          question: "Is there a subscription fee for my account?",
          answer: [
            "No subscription fee is required. Charges are only applied after the completion of a service request.",
          ],
        },
        {
          question: "Why do I need to provide my credit card information?",
          answer: [
            "Your credit card will be billed automatically once a service is completed. If you're dissatisfied, we will either send a professional to address the issue or offer a refund (refer to our User Protection Plan for details).",
          ],
        },
      ],
    },
    {
      category: "Booking",
      questions: [
        {
          question: "Can I schedule a service in advance?",
          answer: [
            "Yes, you have the option to book either immediately (ASAP) or schedule for a later date.",
          ],
        },
        {
          question: "Can I request the same professional for future services?",
          answer: [
            "We're pleased you had a great experience! Currently, your request will be sent to all available professionals in the relevant category to ensure prompt service. We are working on a feature that will allow you to request a specific professional based on their availability.",
          ],
        },
      ],
    },
    {
      category: "Appointment & Cancellation",
      questions: [
        {
          question: "Do I need to be present during the appointment?",
          answer: [
            "You or a representative (at least 18 years old) must be present for appointments that require entry into your home or office. For outdoor services, it is not mandatory but recommended to ensure proper service.",
          ],
        },
        {
          question: "What if I need to cancel my appointment?",
          answer: [
            "You may cancel without a fee until the professional is en route. Cancellations made after the professional is on their way incur a cancellation fee equal to the job minimum for that service. If the professional fails to arrive within a reasonable time after the appointment window, the cancellation fee will be waived.",
          ],
        },
        {
          question: "Can a professional cancel the appointment?",
          answer: [
            "A professional may cancel within 15 minutes of accepting the job without incurring a fee. Cancellations after this period but before the appointment window expires will result in a fee equal to the job minimum for that service. Failure to show up after a reasonable time post-appointment window will also incur a fee equal to the job minimum for that service.",
          ],
        },
        {
          question: "Can I request a service at any time?",
          answer: [
            "Requests can be made anytime, though availability is typically higher during regular business hours.",
          ],
        },
      ],
    },
    {
      category: "Pricing",
      questions: [
        {
          question: "How are service charges determined?",
          answer: [
            "Each service has a rate card available for review. Rates are based on industry standards and may be hourly or based on specific metrics (e.g., amount of junk, carpet size). Minimum charges apply, and any materials used will be billed separately. Ensure you understand both the rate and minimum charge before requesting a service.",
          ],
        },
        {
          question: "Will I receive an estimate before the service starts?",
          answer: [
            "Rate cards provide initial pricing information. For further details on time or materials, we recommend communicating directly with the professional once the job is accepted. If you believe you've been overcharged, contact us for assistance.",
          ],
        },
      ],
    },
    {
      category: "Payment & Promotions",
      questions: [
        {
          question: "When is payment due?",
          answer: ["Your credit card will be charged upon service completion."],
        },
        {
          question: "Are promotional credits automatically applied?",
          answer: [
            "Yes, any available credits will be applied before billing your credit card.",
          ],
        },
        {
          question: "Is there a maximum limit on credits?",
          answer: ["No, there is no cap on the amount of credits you can earn."],
        },
        {
          question: "Do promotional credits expire?",
          answer: [
            "Yes, promotional credits have expiration dates. Check each promotion's terms to ensure you use them before they expire.",
          ],
        },
      ],
    },
    {
      category: "User Protection Plan",
      questions: [
        {
          question: "What does the User Protection Plan include?",
          answer: [
            "If you are unsatisfied with the service, we will send a professional to rectify the issue or offer a refund. Details are available in the User Protection Plan.",
          ],
        },
      ],
    },
    {
      category: "Professionals",
      questions: [
        {
          question: "How can I be assured of the professional's quality?",
          answer: [
            "We partner with top companies and ensure all professionals meet our high standards. If service quality does not meet expectations, contact us for resolution or a refund (refer to the User Protection Plan).",
          ],
        },
        {
          question: "Will I be informed of the professional assigned to my request?",
          answer: [
            "Yes, once a professional accepts the job, you will receive their name, company, contact information, rating, and picture.",
          ],
        },
        {
          question: "Are professionals insured and licensed?",
          answer: [
            "Yes, professionals who require insurance or licenses have provided proof of coverage before joining our platform.",
          ],
        },
      ],
    },
  ];

  useEffect(() => {
    if (contact_us_status === asyncStatus.SUCCEEDED) {
      _clearDataState();
    }
  }, [contact_us_status]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Navbar />

      {/* ── Hero banner ── */}
      <div className={css.img_wrapper}>
        <Stack
          sx={{
            height: "100%",
            width: "100%",
            background: "linear-gradient(to bottom, rgba(0,0,0,0.35) 0%, rgba(0,0,0,0.55) 100%)",
          }}
          alignItems="center"
          justifyContent="center"
          spacing={2}
        >
          <Typography
            sx={{
              color: "white",
              fontWeight: 900,
              fontSize: { xl: "72px", lg: "72px", md: "60px", sm: "44px", xs: "38px" },
              textAlign: "center",
              lineHeight: 1.1,
              letterSpacing: "-1px",
              fontFamily: "Raleway",
            }}
          >
            Help Center
          </Typography>
          <Typography
            sx={{
              color: "rgba(255,255,255,0.8)",
              fontSize: { sm: "18px", xs: "15px" },
              textAlign: "center",
              maxWidth: 480,
              px: 2,
            }}
          >
            Everything you need to know about Done Right Away
          </Typography>
        </Stack>
      </div>

      {/* ── Contact card (floats over hero) ── */}
      <Container maxWidth="lg" sx={{ position: "relative" }}>
        <Box
          sx={{
            position: "relative",
            top: "-100px",
            borderRadius: "16px",
            overflow: "hidden",
            boxShadow: "0 8px 40px rgba(0,0,0,0.12)",
            backgroundColor: "white",
          }}
        >
          <Grid container alignItems="stretch">
            {/* Left: contact form */}
            <Grid item xl={8} lg={8} md={8} sm={12} xs={12}>
              <Stack sx={{ height: "100%" }} p={{ xs: 3, sm: 5 }} gap={3}>
                {/* Section title */}
                <Stack direction="row" alignItems="center" gap={2}>
                  <Box
                    sx={{
                      width: 5,
                      height: 40,
                      borderRadius: "3px",
                      background: `linear-gradient(180deg, ${themeOrange} 0%, #C53F10 100%)`,
                    }}
                  />
                  <Typography sx={{ fontWeight: "700", fontSize: "28px", color: "#1a1a1a" }}>
                    Contact Us
                  </Typography>
                </Stack>

                {/* Fields */}
                <Grid container spacing={2}>
                  {fields.map(({ _id, label, value, onChange, type, disabled }, i) => (
                    <Grid key={i} item xl={6} lg={6} md={6} sm={12} xs={12}>
                      <TextField
                        fullWidth
                        label={label}
                        type={type}
                        value={value}
                        onChange={onChange}
                        disabled={disabled}
                        size="small"
                        sx={{ "& .MuiOutlinedInput-root": { borderRadius: "10px" } }}
                      />
                    </Grid>
                  ))}
                  {vendorFields.map(({ _id, label, value, onChange, type, disabled }, i) => {
                    const isTextArea = _id === 3;
                    return (
                      <Grid
                        key={i}
                        item
                        xl={isTextArea ? 12 : 6}
                        lg={isTextArea ? 12 : 6}
                        md={isTextArea ? 12 : 6}
                        sm={12}
                        xs={12}
                      >
                        <TextField
                          fullWidth
                          label={label}
                          type={type}
                          value={value}
                          onChange={onChange}
                          disabled={disabled}
                          multiline={isTextArea}
                          rows={isTextArea ? 4 : 1}
                          size="small"
                          sx={{ "& .MuiOutlinedInput-root": { borderRadius: "10px" } }}
                        />
                      </Grid>
                    );
                  })}
                </Grid>

                {/* Submit button */}
                <Button
                  variant="contained"
                  fullWidth
                  disabled={_isEmpty() || isLoading}
                  onClick={_handleSubmit}
                  sx={{
                    background: _isEmpty()
                      ? "#e0e0e0"
                      : "linear-gradient(180deg, #F15A24 0%, #C53F10 100%)",
                    borderRadius: "10px",
                    textTransform: "none",
                    fontWeight: "700",
                    fontSize: "15px",
                    py: 1.5,
                    boxShadow: _isEmpty() ? "none" : "0 4px 12px rgba(241,90,36,0.3)",
                    "&:hover": {
                      background: _isEmpty()
                        ? "#e0e0e0"
                        : "linear-gradient(180deg, #e04d1a 0%, #b3370d 100%)",
                    },
                    "&.Mui-disabled": { color: "#aaa" },
                  }}
                >
                  {isLoading ? (
                    <CircularProgress size={20} sx={{ color: "white" }} />
                  ) : (
                    "Send Message"
                  )}
                </Button>
              </Stack>
            </Grid>

            {/* Right: service man image panel */}
            <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
              <Stack
                justifyContent="flex-end"
                sx={{
                  height: { xl: "100%", lg: "100%", md: "100%", sm: "80vw", xs: "70vw" },
                  width: "100%",
                }}
              >
                <Stack
                  justifyContent="flex-end"
                  gap={2.5}
                  className={css.service_man_img}
                  p={4}
                  pb={3}
                >
                  <Typography className={css.banner_img_txt}>LETS</Typography>
                  <Typography
                    className={css.banner_img_txt}
                    sx={{ color: "white !important" }}
                  >
                    GROW
                  </Typography>
                  <Typography className={css.banner_img_txt}>TOGETHER</Typography>

                  <button
                    onClick={() => navigate("/")}
                    className={css.contact_us_btn}
                  >
                    Support{" "}
                    <MdKeyboardDoubleArrowRight style={{ fontSize: "15px" }} />
                  </button>

                  <Stack direction="row" alignItems="center" justifyContent="center" gap={1}>
                    {[FaFacebook, FaInstagram, FaTwitter].map((Icon, i) => (
                      <IconButton
                        key={i}
                        sx={{
                          borderRadius: "10px",
                          p: "6px",
                          transition: "all 0.3s ease-in-out",
                          "&:hover": { backgroundColor: themeOrange },
                        }}
                      >
                        <Icon style={{ color: "white", fontSize: "20px" }} />
                      </IconButton>
                    ))}
                  </Stack>
                </Stack>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </Container>

      {/* ── FAQ section ── */}
      <Container maxWidth="lg" sx={{ pb: 10 }}>
        {/* Section heading */}
        <Stack alignItems="center" spacing={1} sx={{ mb: 6 }}>
          <Typography
            sx={{
              fontSize: { xl: "36px", lg: "36px", md: "32px", sm: "26px", xs: "24px" },
              fontWeight: "500",
              color: "#333",
              fontFamily: "Raleway",
              textAlign: "center",
            }}
          >
            Frequently Asked{" "}
            <Typography
              component="span"
              sx={{
                fontSize: { xl: "36px", lg: "36px", md: "32px", sm: "26px", xs: "24px" },
                fontWeight: "700",
                color: "#333",
                fontFamily: "Raleway",
              }}
            >
              Questions
            </Typography>
          </Typography>
          <Box
            sx={{
              width: 60,
              height: 4,
              borderRadius: "2px",
              background: `linear-gradient(90deg, ${themeOrange} 0%, #C53F10 100%)`,
            }}
          />
        </Stack>

        <Stack spacing={5}>
          {faqsData.map(({ category, questions, description }) => (
            <Stack key={category} spacing={2}>
              {/* Category header */}
              <Stack direction="row" alignItems="center" gap={1.5}>
                <Box
                  sx={{
                    width: 4,
                    height: 28,
                    borderRadius: "2px",
                    background: `linear-gradient(180deg, ${themeOrange} 0%, #C53F10 100%)`,
                    flexShrink: 0,
                  }}
                />
                <Typography
                  sx={{
                    fontSize: { xl: "20px", lg: "20px", md: "20px", sm: "18px", xs: "17px" },
                    fontWeight: "700",
                    color: "#1a1a1a",
                  }}
                >
                  {category}
                </Typography>
              </Stack>

              {/* Accordions */}
              <Stack spacing={1.5}>
                {questions.map(({ question, answer }) => (
                  <Accordion
                    key={question}
                    disableGutters
                    elevation={0}
                    sx={{
                      borderRadius: "12px !important",
                      border: "1.5px solid #ebebeb",
                      overflow: "hidden",
                      "&:before": { display: "none" },
                      "&.Mui-expanded": {
                        border: `1.5px solid ${themeOrange}40`,
                        boxShadow: `0 4px 16px ${themeOrange}15`,
                      },
                    }}
                  >
                    <AccordionSummary
                      expandIcon={
                        <ExpandMoreIcon sx={{ color: themeOrange }} />
                      }
                      sx={{
                        px: 2.5,
                        py: 0.5,
                        "&.Mui-expanded": { backgroundColor: `${themeOrange}06` },
                      }}
                    >
                      <Typography sx={{ fontSize: "15px", fontWeight: "600", color: "#1a1a1a", lineHeight: 1.5 }}>
                        {question}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails
                      sx={{
                        backgroundColor: "#FEEEE9",
                        px: 2.5,
                        py: 2,
                        borderTop: `1px solid ${themeOrange}20`,
                      }}
                    >
                      {answer.map((item, i) => (
                        <Typography
                          key={i}
                          sx={{
                            fontSize: "14px",
                            color: "#444",
                            lineHeight: 1.7,
                            mb: answer.length > 1 && i < answer.length - 1 ? 0.5 : 0,
                          }}
                        >
                          {answer.length > 1 ? `• ${item}` : item}
                        </Typography>
                      ))}
                    </AccordionDetails>
                  </Accordion>
                ))}
              </Stack>

              {description && (
                <Typography sx={{ fontSize: "13px", color: "#888", pl: 0.5 }}>
                  {description}
                </Typography>
              )}
            </Stack>
          ))}
        </Stack>
      </Container>

      <Footer />
    </div>
  );
};

export default HelpCenter;
